import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Reveal from '../../components/ui/Reveal';
import BreadcrumbTrail from '../../components/ui/BreadcrumbTrail';
import HeroSection from './components/HeroSection';
import QuickStatsSection from './components/QuickStatsSection';
import VisitorStatsSection from './components/VisitorStatsSection';
import OrganizationPreview from './components/OrganizationPreview';
import PublicServicesPreview from './components/PublicServicesPreview';
import NewsPreview from './components/NewsPreview';
import MediaPreview from './components/MediaPreview';
import HistorySection from './components/HistorySection';
import MapSection from './components/MapSection';
import { useVisitorTracking } from '../../hooks/useVisitorTracking';

const HomeDashboard = () => {
  // Initialize visitor tracking
  useVisitorTracking();

  useEffect(() => {
    // Set page title
    document.title = 'หน้าหลัก - ที่ว่าการอำเภอเทิง';
    
    // Check for saved language preference
    const savedLanguage = localStorage.getItem('preferred-language');
    if (!savedLanguage) {
      localStorage.setItem('preferred-language', 'th');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="flex-1">
        {/* Breadcrumb Navigation */}
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <BreadcrumbTrail />
        </div>

        {/* Hero Section with Vision & Mission */}
        <Reveal y={18} duration={760} scaleFrom={0.985}>
          <HeroSection />
        </Reveal>


        {/* Quick Statistics */}
        <Reveal y={16} delay={80} duration={700} scaleFrom={0.985}>
          <QuickStatsSection />
        </Reveal>

        {/* Organization Structure Preview */}
        <Reveal y={16} delay={120} duration={740} scaleFrom={0.985}>
          <OrganizationPreview />
        </Reveal>

        {/* History Section */}
        <Reveal y={16} delay={140} duration={760} scaleFrom={0.985}>
          <HistorySection />
        </Reveal>

        {/* Map Section */}
        <Reveal y={16} delay={150} duration={780} scaleFrom={0.985}>
          <MapSection />
        </Reveal>

        {/* News Section (from database) */}
        <Reveal y={16} delay={160} duration={780} scaleFrom={0.985}>
          <NewsPreview />
        </Reveal>

        {/* Media Section (from database) */}
        <Reveal y={16} delay={180} duration={780} scaleFrom={0.985}>
          <MediaPreview />
        </Reveal>

        {/* Public Services Preview */}
        <Reveal y={16} delay={200} duration={820} scaleFrom={0.985}>
          <PublicServicesPreview />
        </Reveal>

        {/* Visitor Statistics */}
        <Reveal y={16} delay={240} duration={840} scaleFrom={0.985}>
          <VisitorStatsSection />
        </Reveal>
      </main>
      {/* Footer */}
      <footer className="bg-primary text-primary-foreground py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">ที่ทำการปกครองอำเภอเทิง</h3>
              <p className="text-sm opacity-90 leading-relaxed">
                ให้บริการประชาชนด้วยความรวดเร็ว โปร่งใส และเป็นธรรม
                เพื่อการพัฒนาคุณภาพชีวิตของประชาชนในอำเภอเทิง
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">ติดต่อเรา</h3>
              <div className="space-y-2 text-sm opacity-90">
                <p>25 ถนนพิศาล ตำบลเทิง อำเภอเทิง</p>
                <p>จังหวัดเชียงราย 57160</p>
                <p>โทร: 053-795-345</p>
                <p>อีเมล: districtthoeng@gmail.com</p>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">เวลาทำการ</h3>
              <div className="space-y-2 text-sm opacity-90">
                <p>วันจันทร์ - วันศุกร์</p>
                <p>08:30 - 16:30 น.</p>
                <p className="mt-4">บริการออนไลน์ 24 ชั่วโมง</p>
              </div>
            </div>
          </div>
          <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center">
            <p className="text-sm opacity-75">
              © {new Date()?.getFullYear()} ที่ว่าการอำเภอเทิง สงวนลิขสิทธิ์
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomeDashboard;